<template>
  <div>
    <CustomAlert :show-alert="submitError" alert-type="error">
      <span class="body-2">{{ submitErrorMsg }}</span>
    </CustomAlert>
    <v-data-table
      :footer-props="{
        'items-per-page-text': 'Datensätze pro Seite',
        'items-per-page-all-text': 'Alle',
        'page-text': '{0}-{1} von {2}'
      }"
      :headers="headers"
      :items="items"
      :items-per-page="10"
      class="elevation-1"
      :height="500"
    >
      <template #[`item.leadRegion`]="{ item }">
        <span v-html="item.leadRegion"></span>
      </template>
      <template #[`item.documents`]="{ item }">
        <span v-html="item.documents"></span>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import CustomAlert from '@/components/CustomAlert'
import { planningService } from '@/services/'
export default {
  components: {
    CustomAlert
  },
  data: () => ({
    content: {},
    validationResult: null,
    items: [],
    fetchedData: [],
    submitError: false,
    submitErrorMsg: ''
  }),
  created: function() {
    // argument is cms api-endpoint
    this.generateHeaders()
    this.fetchDocuments()
  },
  methods: {
    generateHeaders() {
      this.headers = [
        {
          text: 'Leitregion',
          value: 'leadRegion',
          sortable: false
        },
        {
          text: 'Anzahl Dokumente',
          value: 'documents',
          align: 'start'
        }
      ]
    },
    async fetchDocuments() {
      planningService
        .getRemainingOrders()
        .then(response => {
          this.items = response
          this.submitError = false
        })
        .catch(e => {
          this.submitError = true
          this.submitErrorMsg = this.getError(e.response.status)
        })
    },
    getError: function(errorKey) {
      return this.$store.getters.error({
        errorKey: errorKey,
        route: this.$route.name
      })
    }
  }
}
</script>

<style></style>
